import Effect from "../Effect";
class FeedbackDelay extends Effect {

	constructor(path, number) {
		super("FeedbackDelay", FeedbackDelay.nice_name, path, number);

		this.createParameter("time", {name: "Time", min: 0, max: 1, step: 0.1});

		this.createParameter("feedback", {name: "Feedback", min: 0, max: 1, step: 0.05,
		default: 0.7});

		this.createParameter("filter", {name: "Filter", min: 20, max: 4000, step: 10, scale: "log2"});

		var mix = this.createParameter("mix", {name: "Mix", min: 0, max: 100, step: 1});

    mix.on('change', this.handleMixChange.bind(this));

    this.gain1 = false;
    this.gain2 = false;
	}

  handleMixChange(event) {
    if(this.gain1 !== false) {
      this.gain2.gain.setValueAtTime(event.normalized/127, 0);
      this.gain1.gain.setValueAtTime(1-event.normalized/127, 0);
    }
  }

	createNodes(context) {
		this.delay = context.createDelay();
		this.inputNode = context.createGain();
		this.gain1 = context.createGain();
		this.gain2 = context.createGain();

		this.feedback = context.createGain();

		this.filter = context.createBiquadFilter();

		this.filter.type = "bandpass";
		this.filter.Q.value  = 1.5;


		this.delay.connect(this.filter);

		this.filter.connect(this.feedback);
		this.filter.connect(this.gain2);
		this.feedback.connect(this.delay);

		this.inputNode.connect(this.delay);
		this.inputNode.connect(this.gain1);


		this.gain2.gain.setValueAtTime(this.getParameterByName('mix').normalized/127, 0);
		this.gain1.gain.setValueAtTime(1-this.getParameterByName('mix').normalized/127, 0);

		this.getParameterByName('time').setParam(this.delay.delayTime);
		this.getParameterByName('feedback').setParam(this.feedback.gain);
		this.getParameterByName('filter').setParam(this.filter.frequency);

		return {
			connect: (node) => {
				this.gain1.connect(node);
        this.gain2.connect(node);
			},
			disconnect: (node) => {
				this.gain1.disconnect(node);
        this.gain2.disconnect(node);
			},
			input: this.inputNode
		};
	}
}

FeedbackDelay.nice_name = "Feedback Delay";

export default FeedbackDelay;
